import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, BadgeCheck, XCircle } from "lucide-react";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { api, apiError } from "@/lib/api";

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const [status, setStatus] = useState("loading"); // loading | ok | error
    const [message, setMessage] = useState("");
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        const token = params.get("token");
        if (!token) { setStatus("error"); setMessage("Missing verification token."); return; }
        (async () => {
            try {
                const { data } = await api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`);
                setStatus("ok"); setMessage(data.message || "Email verified.");
            } catch (err) {
                setStatus("error"); setMessage(apiError(err.response?.data?.detail) || "Verification failed.");
            }
        })();
    }, [params]);

    return (
        <AuthLayout title="Email Verification" subtitle="Confirming your WhiteWater AI account.">
            <div className="text-center py-6" data-testid="verify-email-status">
                {status === "loading" && <Loader2 className="w-10 h-10 text-volt mx-auto animate-spin" />}
                {status === "ok" && <BadgeCheck className="w-12 h-12 text-success mx-auto" />}
                {status === "error" && <XCircle className="w-12 h-12 text-alert mx-auto" />}
                <p className="mt-4 text-sm text-muted-foreground">{message || "Verifying..."}</p>
                <Link to="/dashboard" className="inline-block mt-6 text-volt hover:underline text-sm" data-testid="verify-continue">
                    Continue to WhiteWater AI
                </Link>
            </div>
        </AuthLayout>
    );
}
